

export interface ViewItem {
  key: string;
  enabled: boolean;
  default?: string;
  options?: string[]; // options for the view item, if none, then all options are applied to
}

export interface MetricUniversalDisplay {
  key: string;
  enabled: boolean;
  button1: ViewItem;
  button2: ViewItem;
  button3: ViewItem;
  button4: ViewItem;
}

export interface ViewSettings {
  accounts: string[];
  metricUniversalDisplay: MetricUniversalDisplay;
  zipcodeDisplayMap: ViewItem;
  zipcodeDisplayList: ViewItem;
  hourlyDisplay: ViewItem;
  domainDisplayList: ViewItem;
  appDisplayList: ViewItem;
  metricCards: ViewItem[];
  performanceBreakdown: ViewItem;
}

export const DEFAULT_VIEW_SETTINGS: ViewSettings = {
  accounts: [],
  metricUniversalDisplay: {
    key: 'metricUniversalDisplay',
    enabled: true,
    button1: { key: 'button1', enabled: true },
    button2: { key: 'button2', enabled: true },
    button3: { key: 'button3', enabled: true },
    button4: { key: 'button4', enabled: true },
  },
  zipcodeDisplayMap: { key: 'zipcodeDisplayMap', enabled: true },
  zipcodeDisplayList: { key: 'zipcodeDisplayList', enabled: true },
  hourlyDisplay: { key: 'hourlyDisplay', enabled: true },
  domainDisplayList: { key: 'domainDisplayList', enabled: true },
  appDisplayList: { key: 'appDisplayList', enabled: true },
  metricCards: [],
  performanceBreakdown: { key: 'performanceBreakdown', enabled: true },
};